var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'mask-img',
  {
    'mask-img-m': _vm.isMobile
  }
]},[_c('div',{staticClass:"container"},[(_vm.canvasImgUrl)?_c('img',{staticClass:"save-img",attrs:{"crossorigin":"anonymous","src":_vm.canvasImgUrl}}):_vm._e()]),(_vm.isMobile)?_c('p',{staticClass:"tip-text"},[_vm._v(_vm._s(_vm.$t('pubcourse.downloadImg.save')))]):_vm._e(),_c('i',{staticClass:"eeo-icon-circle-close close",on:{"click":_vm.hideMask}}),_c('div',{staticStyle:{"overflow":"hidden","width":"0px","height":"0px"}},[_c('canvas',{ref:"QRImageCanvas",attrs:{"id":"myCanvas","width":"1120px","height":"1464px"}},[_vm._v("\n      The device is not supported canvas.\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }